module.exports = __webpack_public_path__ + "static/media/home_l.c7910426.svg";